import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="checklists" />;

export const Route = createFileRoute("/en/downloads/checklists/$slug")({
  loader: ({ params }) => loadContentMeta("checklists", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/downloads/checklists/${params.slug}`, loaderData),
  component: ContentPostRoute,
});
